// extracted by mini-css-extract-plugin
module.exports = {"info":"UploadModal_style_info___8thg","ctrlPanel":"UploadModal_style_ctrlPanel__oEkpL","item":"UploadModal_style_item__3WSUt","close":"UploadModal_style_close__3JauT"};